module.exports = __webpack_public_path__ + "img/6.875a462f.png";